import { RegistrationFormScreens } from "app/utils/const";
import { FormattedMessage } from "react-intl";

type ContinueButtonContainerProps = {
  setSelectedScreen: (selectedScreen: string) => void;
  validateFormDetails: () => void;
};

const ContinueButtonContainer = ({
  setSelectedScreen,
  validateFormDetails,
}: ContinueButtonContainerProps): JSX.Element => {
  return (
    <div className="continue-button-container">
      <button
        className="nav-bar__nav-item--contact nav-bar__nav-item--back--button"
        onClick={() => {
          setSelectedScreen(RegistrationFormScreens.ACCOUNT_DETAILS);
        }}
      >
        <FormattedMessage
          tagName="div"
          id="account-verification-select-document-back-button"
        />
      </button>
      <button
        className="nav-bar__nav-item--contact nav-bar__nav-item--contact--button"
        onClick={() => {
          return validateFormDetails();
        }}
      >
        <FormattedMessage tagName="div" id="home-register-continue" />
      </button>
    </div>
  );
};

export default ContinueButtonContainer;
